import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { WHATSAPP_CHAT_URL } from '../../config/contactLinks';
import PageLayout from '../../components/feature/PageLayout';
import PageHero from '../../components/feature/PageHero';
import FadeIn from '../../components/base/FadeIn';
import referans1 from '../../assets/images/referans-1.jpeg';
import referans2 from '../../assets/images/referans-2.jpeg';
import referans3 from '../../assets/images/referans-3.jpeg';
import referans4 from '../../assets/images/referans-4.jpeg';
import referans5 from '../../assets/images/referans-5.jpeg';
import referans6 from '../../assets/images/referans-6.jpeg';
import referans7 from '../../assets/images/referans-7.jpeg';
import referans8 from '../../assets/images/referans-8.jpeg';
import referanslarHero from '../../assets/images/hero-referanslar.jpg';

const photos = [
  { src: referans1, label: 'Temizlik Çalışması' },
  { src: referans2, label: 'Temizlik Çalışması' },
  { src: referans3, label: 'Temizlik Çalışması' },
  { src: referans4, label: 'Temizlik Çalışması' },
  { src: referans5, label: 'Temizlik Çalışması' },
  { src: referans6, label: 'Temizlik Çalışması' },
  { src: referans7, label: 'Temizlik Çalışması' },
  { src: referans8, label: 'Temizlik Çalışması' },
];

const testimonials = [
  { name: 'Ayşe Kaya', role: 'Ev Sahibi — Villa Temizliği', comment: 'Villam her zamankinden çok daha temiz! NiğPak ekibi gerçekten profesyonel. Her detaya özen gösterdiler, köşeleri bile atlamadılar. Kesinlikle tavsiye ediyorum.', rating: 5, initial: 'A' },
  { name: 'Mehmet Arslan', role: 'İşyeri Sahibi — Mağaza Temizliği', comment: 'Mağazamız için aylık kontrat yaptık. Her ay düzenli geliyor, hiçbir sorun yaşamadık. Fiyat-kalite oranı mükemmel. Niğde\'de bu kadar kaliteli bir temizlik firması görmemiştim.', rating: 5, initial: 'M' },
  { name: 'Fatma Demir', role: 'Mülk Sahibi — Kiracı Sonrası', comment: 'Kiracım çıktıktan sonra dairem berbat durumdaydı. NiğPak ekibi adeta sihir gibi temizledi. Yeni kiracım daireye girince inanamamış! Harika bir iş çıkardılar.', rating: 5, initial: 'F' },
  { name: 'Ali Yılmaz', role: 'Restoran İşletmecisi — Restoran Temizliği', comment: 'Restoranımızın mutfak temizliğini NiğPak yapıyor. Hijyen standartlarına çok dikkat ediyorlar. Sağlık denetiminde tam puan aldık. Çok memnunuz!', rating: 5, initial: 'A' },
  { name: 'Zeynep Şahin', role: 'Ofis Müdürü — Ofis Temizliği', comment: 'Ofisimiz her sabah tertemiz. Çalışanlarımızın morali çok yüksek, temiz ortamda çok daha verimli çalışıyoruz. NiğPak\'ı kesinlikle tavsiye ediyorum.', rating: 5, initial: 'Z' },
  { name: 'Hasan Öztürk', role: 'Apartman Yöneticisi — Apartman Temizliği', comment: 'Apartmanımızın ortak alanlarını temizliyorlar. Saatinde geliyorlar, işlerini özenle yapıyorlar. Sakinlerin hepsi çok memnun. Uzun süredir çalışıyoruz.', rating: 5, initial: 'H' },
  { name: 'Selin Çelik', role: 'Ev Sahibi — Daire Temizliği', comment: 'Haftalık temizlik paketi aldım, çok memnunum. Ekip her zaman güler yüzlü ve dakik geliyor. Kullandıkları ürünler koku bırakmıyor, çok kaliteli.', rating: 5, initial: 'S' },
  { name: 'Kadir Boz', role: 'Kafe Sahibi — Kafe Temizliği', comment: 'Kafemiz için aylık derin temizlik yaptırıyoruz. Özellikle mutfak temizliğindeki titizlikleri inanılmaz. Müşterilerimiz temizliğimizi çok beğeniyor.', rating: 5, initial: 'K' },
  { name: 'Elif Yurt', role: 'Daire Sahibi — İnşaat Sonrası', comment: 'Tadilat bitişi sonrasında daireyi mükemmel temizlediler. Toz, kir, boya lekesi hiç kalmadı. Çok hızlı ve profesyonel bir ekip, gerçekten tavsiye ederim.', rating: 5, initial: 'E' },
];

export default function ReferanslarPage() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const prev = () => setLightbox(i => (i !== null ? (i - 1 + photos.length) % photos.length : null));
  const next = () => setLightbox(i => (i !== null ? (i + 1) % photos.length : null));

  return (
    <PageLayout>
      <PageHero
        label="Müşteri Yorumları"
        title="Referanslarımız"
        subtitle="500'den fazla memnun müşterimizin deneyimleri. Her projede aynı özen, aynı kalite."
        bgImage={referanslarHero}
      />

      {/* Stats */}
      <section className="py-16 bg-[#f7f8fc]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <FadeIn>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                { value: '500+', label: 'Değerlendirme', icon: 'ri-star-fill' },
                { value: '5.0', label: 'Ortalama Puan', icon: 'ri-award-fill' },
                { value: '%98', label: 'Tekrar Tercih', icon: 'ri-repeat-line' },
                { value: '5+', label: 'Yıllık Güven', icon: 'ri-calendar-check-line' },
              ].map(s => (
                <div key={s.label} className="bg-white border border-gray-100 rounded-xl p-6 flex flex-col items-center gap-2">
                  <span className="w-10 h-10 flex items-center justify-center bg-gold/10 rounded-xl">
                    <i className={`${s.icon} text-gold text-lg`}></i>
                  </span>
                  <div className="text-3xl font-extrabold text-navy">{s.value}</div>
                  <div className="text-gray-400 text-[11px] font-semibold uppercase tracking-wider">{s.label}</div>
                </div>
              ))}
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <FadeIn className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[2px] bg-gold rounded-full" />
              <p className="text-gold text-[11px] font-bold uppercase tracking-[0.25em]">Gerçek Sonuçlar</p>
            </div>
            <h2 className="text-4xl font-extrabold text-navy tracking-tight">Çalışmalarımızdan</h2>
            <p className="text-gray-400 text-sm mt-2">Tamamladığımız işlerden gerçek fotoğraflar. Büyütmek için tıklayın.</p>
          </FadeIn>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {photos.map((photo, i) => (
              <FadeIn key={i} delay={(i % 4) * 0.07}>
                <div
                  className="group relative rounded-xl overflow-hidden cursor-pointer"
                  style={{ aspectRatio: '1/1' }}
                  onClick={() => setLightbox(i)}
                >
                  <img
                    src={photo.src}
                    alt={photo.label}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-navy/0 group-hover:bg-navy/40 transition-colors duration-300 flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-12 h-12 flex items-center justify-center bg-white/90 rounded-full">
                      <i className="ri-zoom-in-line text-navy text-xl"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-navy/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <p className="text-white text-xs font-semibold">{photo.label}</p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence>
        {lightbox !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
            onClick={() => setLightbox(null)}
          >
            <button
              className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
              onClick={() => setLightbox(null)}
            >
              <i className="ri-close-line text-xl"></i>
            </button>

            <button
              className="absolute left-4 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer z-10"
              onClick={e => { e.stopPropagation(); prev(); }}
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>

            <motion.img
              key={lightbox}
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.92 }}
              transition={{ duration: 0.25 }}
              src={photos[lightbox].src}
              alt={photos[lightbox].label}
              className="max-w-full max-h-[85vh] object-contain rounded-xl"
              onClick={e => e.stopPropagation()}
            />

            <button
              className="absolute right-4 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer z-10"
              onClick={e => { e.stopPropagation(); next(); }}
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>

            <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2">
              {photos.map((_, i) => (
                <button
                  key={i}
                  onClick={e => { e.stopPropagation(); setLightbox(i); }}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${i === lightbox ? 'bg-gold w-5' : 'bg-white/30'}`}
                />
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Testimonials */}
      <section className="py-24 bg-navy">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <FadeIn className="mb-14">
            <div className="flex items-center gap-1.5 mb-4">
              {[1,2,3,4,5].map(i => (
                <span key={i} className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-gold text-lg"></i>
                </span>
              ))}
              <span className="text-white/60 text-sm ml-2">500+ Değerlendirme</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">Müşterilerimiz Ne Diyor?</h2>
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {testimonials.map((t, i) => (
              <FadeIn key={t.name} delay={(i % 3) * 0.09}>
                <div className="bg-white/5 border border-white/10 rounded-xl p-6 hover:border-gold/40 hover:bg-white/[0.07] transition-all h-full flex flex-col">
                  <div className="flex items-center gap-1 mb-5">
                    {[...Array(t.rating)].map((_, idx) => (
                      <span key={idx} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-gold text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-white/80 text-sm leading-[1.8] mb-6 flex-1">&ldquo;{t.comment}&rdquo;</p>
                  <div className="flex items-center gap-3 pt-5 border-t border-white/10">
                    <div className="w-10 h-10 flex items-center justify-center bg-gold rounded-lg shrink-0 text-white font-extrabold text-sm">
                      {t.initial}
                    </div>
                    <div>
                      <p className="text-white font-bold text-sm leading-none">{t.name}</p>
                      <p className="text-white/40 text-xs mt-1">{t.role}</p>
                    </div>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>

          <FadeIn className="mt-14 border-t border-white/10 pt-10 flex flex-col sm:flex-row items-center justify-between gap-6">
            <p className="text-white/60 text-sm">Siz de NiğPak Temizlik ailesine katılın.</p>
            <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
              className="flex items-center gap-2 bg-gold hover:bg-gold-dark text-white font-bold px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-whatsapp-line text-base"></i>
              Teklif İçin Yazın
            </a>
          </FadeIn>
        </div>
      </section>
    </PageLayout>
  );
}
